import { http } from '@/app/lib/http/client'


export interface StorePaymentGateway {
  id: number
  company_id: number
  name: string
  code: string
  is_active: boolean
  sandbox_mode: boolean
  allow_pickup: boolean
  allow_delivery: boolean
  credentials: Record<string, string> | null
  has_private_key?: boolean
  has_access_token?: boolean
  has_webhook_secret?: boolean
  webhook_url?: string | null
  created_at: string
  updated_at: string
}

interface UpdateStorePaymentGatewayData {
  is_active?: boolean
  sandbox_mode?: boolean
  allow_pickup?: boolean
  allow_delivery?: boolean
  credentials?: Record<string, string> | null
}

export const storePaymentGatewayService = {
  getItems: () => {
    return http.get<{ data: StorePaymentGateway[] }>('/store-payment-gateways')
  },

  updateItem: (id: number, data: UpdateStorePaymentGatewayData) => {
    return http.put<{ data: StorePaymentGateway }>(`/store-payment-gateways/${id}`, data)
  },
}
